<template>
    <div class="register__step" data-step="payment" v-bind:class="{'active': $store.state.step == 'payment'}">
        <h3>Payment</h3>
        <p>Please fill out the payment information to complete the registration.</p>

        <template v-if="$store.state.payment.messages.length > 0">
            <div class="alert alert-warning">
                <h6>Payment errors:</h6>
                <ul id="ul-validations">
                    <li v-for="item in $store.state.payment.messages" v-bind:key="item">
                        {{ item }}
                    </li>
                </ul>
            </div>
        </template>
        
        <fieldset class="register__step-fieldset">
            <legend>Your Payment Details</legend>

            <ul class="register__step-fields">
                <li class="register__step-field_plan" style="padding: 0 10px">
                    <p>Selected Plan: <span class="cost">{{ $store.state.signup.plan_details.cost | currency }}</span> <em>annually</em> (<a href="javascript:void(0)" v-on:click="$store.dispatch( 'step_control', { to: 'membership' } );" class="text-white">Change</a>)</p>
                    <small style="display:content" v-html="'*' + $store.state.signup.plan_details.legal"></small>
                    <br/>
                </li>

                <li class="register__step-field register__step-field--third">
                    <div class="card_brand_after">
                        <span class="brand" id="basic-addon1"><i :class="cardBrandClass"></i></span>
                        <input type="text" ref="cardNumInput" class="register__step-field-input card_info" placeholder="#### #### #### ####" maxlength="19" id="cardNumber" name="cardNumber" v-cardformat:formatCardNumber v-model="$store.state.payment.cardNumber">
                    </div>
                    <label for="cardNumber" class="register__step-field-label">Card Number</label>
                </li>
                <li class="register__step-field register__step-field--third">
                    <input type="text" id="cardExp" ref="cardExpInput" name="cardExp" maxlength="7" placeholder="MM / YY" v-cardformat:formatCardExpiry class="register__step-field-input card_info" v-model="$store.state.payment.cardExpiry">
                    <label for="cardExp" class="register__step-field-label">Card Expiration</label>
                </li>
                <li class="register__step-field register__step-field--third">
                    <input type="text" ref="cardCvcInput" id="cardCode" name="cardCode" class="register__step-field-input card_info" placeholder="###" v-model="$store.state.payment.cardCvc"  v-cardformat:formatCardCVC>
                    <label for="cardCode" class="register__step-field-label">Card CVC</label>
                </li>
                
            </ul>
        </fieldset>

        <br />

        <div style="width:100%; text-align:center">
            <img src="/wp-content/uploads/vouched/payment_icons.png" style="max-width:374px;width:100%;max-height:80px" />
        </div>
        
        <br />

        <div class="alert alert--compact alert-info mb-0">
            <h4>Notes and Disclaimers</h4>
            <p class="with-icon"><i class="fal fa-calendar" aria-hidden="true"></i> Your membership to DVC Advantages will be billed annually.</p>
            <p class="with-icon"><i class="fal fa-check" aria-hidden="true"></i> Your membership will begin today and last from one year until today. Your membership will automatically renew at that point, until cancelled.</p>
            <p class="with-icon mb-0"><i class="fal fa-exclamation-triangle" aria-hidden="true"></i> Becoming a premium member requires you to agree to our Terms of Use.</p>
        </div>

        <footer class="register__step-footer">
            <button class="btn btn-secondary" data-direction="back" v-on:click="$store.dispatch( 'step_control', { to: 'membership' } );"><i class="fas fa-chevron-left" aria-hidden="true"></i> Back</button>
            <button class="btn btn-primary" data-direction="next" v-on:click="$store.dispatch( 'step_control', { to: 'complete' } );">Finish <i class="fas fa-chevron-right" aria-hidden="true"></i></button>
        </footer>
    </div>
</template>

<script>
export default {
    name: "DVCARegisterPayment",
    data:  function(){ 
        return {
            cardBrand: null
        }
    },
    computed: {
        cardBrandClass(){
            return this.getBrandClass(this.cardBrand);
        }
    },
    methods: {
        getBrandClass: function (brand) {
            let icon = '';
            brand = brand || 'unknown';
            let cardBrandToClass = {
                'visa': 'fab fa-cc-visa',
                'mastercard': 'fab fa-cc-mastercard',
                'amex': 'fab fa-cc-amex',
                'discover': 'fab fa-cc-discover',
                'diners': 'fab fa-cc-diners-club',
                'jcb': 'fab fa-cc-jcb',
                'unknown': 'fa fa-credit-card',
            }

            if (cardBrandToClass[brand]) {
                icon = cardBrandToClass[brand];
            }

            this.$store.state.payment.cardBrand = brand;

            return icon;
        }
    },
    watch: {
        // handle auto-focus to next field
        // Note: since CVC can be 3 OR 4 digits we don't watch it
        cardNumber: function(val){
          if(this.$cardFormat.validateCardNumber(val)){
            this.$refs.cardExpInput.focus();
          }
        },
        cardExpiry: function (val) {
          if (this.$cardFormat.validateCardExpiry(val)) {
            this.$refs.cardCvcInput.focus();
          }
        }
    },
    mounted(){
        this.$refs.cardNumInput.focus();
    } 
}
</script>
